<div *ngIf="buttonIcon == 'Edit'; else addImageButton" [matTooltip]="'Logo ändern'" [matTooltipPosition]="'above'"
    matTooltipClass="tooltip">
    <button class="edit-btn" (click)="onUploadClicked()">
        <mat-icon class="text-primary">edit</mat-icon>
    </button>
    <!-- <hexagon
        [icon]="'edit'"
        [hover]="true"
        [outerColor]="'var(--app-primary)'"
        (click)="onUploadClicked()"
    >
    </hexagon> -->
</div>

<ng-template #addImageButton>
    <div class="mini-hex-button rightmost">
        <hexagon [icon]="'plus'" [hover]="true" [outerColor]="'var(--app-primary)'" (click)="onUploadClicked()">
        </hexagon>
    </div>
</ng-template>

<input type="file" id="{{ inputId }}" name="{{ inputId }}" [multiple]="allowMultipleUploads"
    accept="{{ acceptedFileTypes }}" style="display: none" />